module.exports = __webpack_public_path__ + "static/media/bettr-create-profile-dark.a66ed3c6.png";